import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import useWindowSize from '../hooks/useWindowSize'

/**
 * ----------------------------------- ATTENTION! -----------------------------------
 * Always implement this component with parent or wrap in div to prevent DOM problems
*/

export default function Resize({
  minBreakpoint = 0,
  maxBreakpoint = Number.POSITIVE_INFINITY,
  children,
}) {
  const { width } = useWindowSize(50)
  if (!width) return null

  const shouldRender = width >= minBreakpoint && width <= maxBreakpoint
  return shouldRender ? children : null
}

Resize.propTypes = exact({
  minBreakpoint: PropTypes.number,
  maxBreakpoint: PropTypes.number,
  children: PropTypes.node.isRequired,
})
